export const InitialDataTeam = () => {
  return {
    team_id: null,
    comp_id: window.localStorage.getItem("company"),
    team_name: null,
    team_leader_id: null,
    team_color: null,
    vehicle_no: null,
    team_phone1: null,
    team_phone2: null,
    team_phone3: null,
    team_status: "A", // A = Active, I = Inactive
    team_username: null,
    team_password: null,
    team_pin: null,
    auto_create_wh: true, // สร้างคลังอัตโนมัติ (ค่าเริ่มต้น: ติ๊กไว้)
    team_members: [], // Array of { member_name, member_phone }
  };
};

